(()=>{'use strict';
const init=()=>{
document.querySelector('[data-studio-variant]')?.addEventListener('change',event=>{const url=new URL(location.href);url.searchParams.set('variant',event.target.value);location.assign(url)});
document.querySelectorAll('.btn-detalles').forEach(button=>{button.addEventListener('click',()=>{const content=button.previousElementSibling;if(!content)return;const expanded=button.dataset.expanded==='true';content.style.maxHeight=expanded?'6.5em':'none';button.dataset.expanded=String(!expanded);button.setAttribute('aria-expanded',String(!expanded));button.textContent=expanded?'Mostrar más detalles':'Mostrar menos detalles'})});
};if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();document.addEventListener('shopify:section:load',init);
})();
(()=>{const boot=()=>{document.querySelectorAll('[data-copy-promo]').forEach(button=>{if(button.dataset.copyReady)return;button.dataset.copyReady='1';button.addEventListener('click',async()=>{const span=button.querySelector('span');try{await navigator.clipboard.writeText(button.dataset.code);span.textContent=button.dataset.copied}catch{span.textContent=button.dataset.copyError}})});const dialog=document.getElementById('StudioSupport'),open=document.querySelector('[data-support-open]');if(dialog&&open&&!open.dataset.ready){open.dataset.ready='1';open.addEventListener('click',()=>dialog.showModal());dialog.querySelector('[data-support-close]').addEventListener('click',()=>dialog.close());dialog.addEventListener('click',e=>{if(e.target!==dialog)return;const r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)dialog.close()});dialog.querySelector('[data-support-send]')?.addEventListener('click',e=>{const query=dialog.querySelector('textarea').value.trim();e.currentTarget.href='https://wa.me/34647041767'+(query?'?text='+encodeURIComponent(query):'')})}const expiry=()=>document.querySelectorAll('[data-studio-promo]').forEach(el=>{if(Date.now()>=Date.parse(el.dataset.expires))el.hidden=true});expiry();window.setInterval(expiry,60000)};if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();document.addEventListener('shopify:section:load',boot)})();
(()=>{
'use strict';
const boot=()=>{
  document.querySelectorAll('[data-description-link]').forEach(link=>{
    if(link.dataset.descriptionReady)return;
    link.dataset.descriptionReady='true';
    link.addEventListener('click',()=>{
      const target=document.getElementById(link.hash.slice(1));
      target?.querySelectorAll('.descripcion-colapsable').forEach(content=>{
        content.style.maxHeight='none';
        const toggle=content.nextElementSibling;
        if(toggle instanceof HTMLButtonElement&&toggle.hasAttribute('data-expanded')){
          toggle.dataset.expanded='true';
          toggle.textContent=link.dataset.lessLabel;
        }
      });
    });
  });
  const price=document.querySelector('[data-pack-price]'),form=document.getElementById('StudioProductForm');
  if(!price||!form||form.dataset.packReady)return;
  const quantity=form.elements.namedItem('quantity');
  if(!quantity)return;
  form.dataset.packReady='true';
  const format=new Intl.NumberFormat(document.documentElement.lang||'es',{style:'currency',currency:price.dataset.packCurrency});
  const update=()=>{
    const count=Number(quantity.value);
    if(!Number.isSafeInteger(count)||count<Number(quantity.min)||!quantity.validity.valid)return;
    price.querySelector('[data-pack-total]').textContent=format.format(Number(price.dataset.packUnit)*count/100);
    const compare=price.querySelector('[data-pack-compare]');
    if(compare)compare.textContent=format.format(Number(compare.dataset.unit)*count/100);
  };
  quantity.addEventListener('input',update);
  quantity.addEventListener('change',update);
  update();
};
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
document.addEventListener('shopify:section:load',boot);
})();

(() => {
  const boot = () => {
    const slot = document.querySelector('[data-product-rating]');
    if (!slot || slot.dataset.observing) return;
    const buy = slot.closest('.product-buy');
    if (!buy) return;
    slot.dataset.observing = 'true';
    const place = () => {
      const badges = [...buy.querySelectorAll('.jdgm-preview-badge')].filter(b => b.dataset.id === slot.dataset.productRating);
      const badge = badges.find(b => b.querySelector('.jdgm-prev-badge')) || badges[0];
      if (badge && badge.parentElement !== slot) slot.replaceChildren(badge);
      badges.forEach(b => { if (b !== badge && b.isConnected) b.remove(); });
    };
    new MutationObserver(place).observe(buy, {childList:true, subtree:true});
    place();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
